import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03d6af06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-listen-again-view" }
const _hoisted_2 = { class: "nav-list" }
const _hoisted_3 = { class: "nav-list-item" }
const _hoisted_4 = { class: "nav-list-item" }

import {computed, inject} from 'vue'
  import {useStore} from 'vuex'
  import {useRouter} from 'vue-router'

  import IconButton from '@/components/inputs/IconButton'
  import ButtonInput from '@/components/inputs/ButtonInput'
  import ContentSection from '@/components/ContentSection'

  import {t} from '@/lib/i18n'

  import {usePreloader} from '@/lib/preloader'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ListenAgainView',
  setup(__props) {

  usePreloader()

  const router = useRouter()
  const store = useStore()
  const bus = inject('bus')

  //const titleText = computed(() => t(store, 'listen_again.title'))
  const contentText = computed(() => t(store, 'listen_again.content'))
  const againText = computed(() => t(store, 'listen_again.actions.again'))
  const nextText = computed(() => t(store, 'listen_again.actions.next'))

  const againClicked = () => {
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click hear another clip'
      }
    })

    router.push({name: 'active.listen'})
  }

  const nextClicked = () => {
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click  move on'
      }
    })
    router.push({name: 'active.outro'})
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ContentSection), { class: "content" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(contentText)), 1)
      ]),
      _: 1
    }),
    _createElementVNode("nav", null, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_unref(IconButton), {
            name: "submit",
            onClick: againClicked
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(againText)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_unref(ButtonInput), {
            priority: "secondary",
            onClick: nextClicked
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(nextText)), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})